module.exports = __webpack_public_path__ + "static/media/darkwebb.d0f1323d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/darkwebb.jpg
// module id = 252
// module chunks = 0